import { render, staticRenderFns } from "./RespuestaCampos.vue?vue&type=template&id=0b582daa&scoped=true"
import script from "./RespuestaCampos.vue?vue&type=script&lang=js"
export * from "./RespuestaCampos.vue?vue&type=script&lang=js"
import style0 from "./RespuestaCampos.vue?vue&type=style&index=0&id=0b582daa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b582daa",
  null
  
)

export default component.exports